import React from "react"
import { Link } from "gatsby"
import tw from "twin.macro"

import FSLogoSvg from "../../images/frontier-science-logo.svg"

const FooterWrapper = tw.footer`bg-ql-blue px-4`
const FooterContainer = tw.div`text-white container mx-auto my-8 flex flex-col lg:flex-row lg:items-center`
const FooterContent = tw.div`flex-1 lg:ml-16`
const FSLogoContainer = tw.a`opacity-75 hover:opacity-100 focus:opacity-100 transition ease-in-out duration-300`
const FSLogo = tw.img`h-16`
const FooterNav = tw.div`flex flex-col sm:flex-row sm:space-x-16 my-4 sm:mt-0`
const FooterNavLinkBase = tw(
  Link
)`opacity-75 hocus:opacity-100 block md:inline-block uppercase my-2 tracking-widest text-sm transition ease-in-out duration-300`
const FooterText = tw.p`text-xs tracking-wider opacity-75`
const Notices = tw(FooterText)`mb-4`
const NoticesLink = tw(
  Link
)`opacity-75 hocus:opacity-100 tracking-wide text-xs transition ease-in-out duration-300`
const NoticesLinkExternal = tw.a`opacity-75 hocus:opacity-100 tracking-wide text-xs transition ease-in-out duration-300`
const LegalNav = tw(Notices)`flex flex-col sm:flex-row sm:space-x-8`

const FooterNavLink = props => (
  <FooterNavLinkBase {...props} activeStyle={tw`opacity-100 font-bold`} />
)

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FSLogoContainer href="https://www.frontierscience.org">
          <FSLogo src={FSLogoSvg} />
        </FSLogoContainer>
        <FooterContent>
          <FooterNav>
            <FooterNavLink to="/">Home</FooterNavLink>
            <FooterNavLink to="/support" partiallyActive>
              Support
            </FooterNavLink>
            <FooterNavLink to="/docs" partiallyActive>
              Documentation
            </FooterNavLink>
          </FooterNav>

          <LegalNav>
            <NoticesLink to="/app-license-agreement">
              App License Agreement
            </NoticesLink>
            <NoticesLinkExternal
              href="https://www.frontierscience.org/legal/privacy-notice.html?site=app"
              target="_blank"
            >
              Privacy and Terms of Use
            </NoticesLinkExternal>
          </LegalNav>

          <FooterText tw="border-t border-white border-opacity-75 pt-4">
            Copyright © {new Date().getFullYear()} Frontier Science and
            Technology Research Foundation, Inc. The App Store and the App Store
            logo are trademarks of Apple Inc. Google Play and the Google Play
            logo are trademarks of Google LLC.
          </FooterText>
        </FooterContent>
      </FooterContainer>
    </FooterWrapper>
  )
}

export default Footer
